export default "__VITE_ASSET__Dhgb6Jm7__"